import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { validateAndClearExpiredToken } from "../utils/tokenUtils";
import LoadingScreen from "./LoadingScreen";
import socketService from "../services/socketService";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user: authUser } = useSelector(state => state.auth);
  const { currentUser } = useSelector(state => state.user);
  const [isValidating, setIsValidating] = useState(true);
  
  useEffect(() => {
    // Add a small delay to prevent flickering during state transitions
    const timer = setTimeout(() => {
      setIsValidating(false);
    }, 50);
    
    return () => clearTimeout(timer);
  }, []);
  
  useEffect(() => {
    if (isAuthenticated) {
      try {
        const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
        const userId = userData.oemPartner?.id || userData.id || userData._id;
        
        if (userId) {
          socketService.startUserValidation(userId, "oempartner");
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
    
    return () => {
      socketService.stopValidation();
    };
  }, [isAuthenticated]);
  
  // Validate token and clear if expired
  const hasValidToken = validateAndClearExpiredToken();
  const userData = sessionStorage.getItem("user");
  
  // Check if user is authenticated with valid token
  const isUserAuthenticated = isAuthenticated && 
    hasValidToken && 
    userData && 
    (authUser || currentUser);
  
  // Show loading state briefly to prevent flickering
  if (isValidating) {
    return <LoadingScreen message="Authenticating..." />;
  }
  
  return isUserAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
